import gql from 'graphql-tag';

const UPDATE_PROJECT_CATEGORY = gql`
  mutation updateProjectCategory (
    $data: ProjectCategoryUpdateInput!
  ) {
    updateProjectCategory (data: $data) {
      id
      name
    }
  }
`;

export default UPDATE_PROJECT_CATEGORY;
